export default "__VITE_ASSET__wg06lnTO__"